import type { Data } from '@repo/strapi-types'

export type ValidColorKey = NonNullable<Data.Component<'utilities.color-tokens'>['color']>

export const colorMapping = {
	'brand-salmon': {
		bg: 'bg-brand-salmon',
		text: 'text-brand-salmon',
		border: 'border-brand-salmon',
		from: 'from-brand-salmon',
	},
	'brand-black': {
		bg: 'bg-brand-black',
		text: 'text-brand-black',
		border: 'border-brand-black',
		from: 'from-brand-black',
	},
	'peach-100': {
		bg: 'bg-peach-100',
		text: 'text-peach-100',
		border: 'border-peach-100',
		from: 'from-peach-100',
	},
	'peach-200': {
		bg: 'bg-peach-200',
		text: 'text-peach-200',
		border: 'border-peach-200',
		from: 'from-peach-200',
	},
	'peach-300': {
		bg: 'bg-peach-300',
		text: 'text-peach-300',
		border: 'border-peach-300',
		from: 'from-peach-300',
	},
	'peach-400': {
		bg: 'bg-peach-400',
		text: 'text-peach-400',
		border: 'border-peach-400',
		from: 'from-peach-400',
	},
	'peach-500': {
		bg: 'bg-peach-500',
		text: 'text-peach-500',
		border: 'border-peach-500',
		from: 'from-peach-500',
	},
	'peach-600': {
		bg: 'bg-peach-600',
		text: 'text-peach-600',
		border: 'border-peach-600',
		from: 'from-peach-600',
	},
	'peach-700': {
		bg: 'bg-peach-700',
		text: 'text-peach-700',
		border: 'border-peach-700',
		from: 'from-peach-700',
	},
	'peach-800': {
		bg: 'bg-peach-800',
		text: 'text-peach-800',
		border: 'border-peach-800',
		from: 'from-peach-800',
	},
	'peach-900': {
		bg: 'bg-peach-900',
		text: 'text-peach-900',
		border: 'border-peach-900',
		from: 'from-peach-900',
	},
	'peach-1000': {
		bg: 'bg-peach-1000',
		text: 'text-peach-1000',
		border: 'border-peach-1000',
		from: 'from-peach-1000',
	},
	'neutral-light-100': {
		bg: 'bg-neutral-light-100',
		text: 'text-neutral-light-100',
		border: 'border-neutral-light-100',
		from: 'from-neutral-light-100',
	},
	'neutral-light-200': {
		bg: 'bg-neutral-light-200',
		text: 'text-neutral-light-200',
		border: 'border-neutral-light-200',
		from: 'from-neutral-light-200',
	},
	'neutral-light-300': {
		bg: 'bg-neutral-light-300',
		text: 'text-neutral-light-300',
		border: 'border-neutral-light-300',
		from: 'from-neutral-light-300',
	},
	'neutral-light-400': {
		bg: 'bg-neutral-light-400',
		text: 'text-neutral-light-400',
		border: 'border-neutral-light-400',
		from: 'from-neutral-light-400',
	},
	'neutral-light-500': {
		bg: 'bg-neutral-light-500',
		text: 'text-neutral-light-500',
		border: 'border-neutral-light-500',
		from: 'from-neutral-light-500',
	},
	'neutral-light-600': {
		bg: 'bg-neutral-light-600',
		text: 'text-neutral-light-600',
		border: 'border-neutral-light-600',
		from: 'from-neutral-light-600',
	},
	'neutral-light-alpha-100': {
		bg: 'bg-neutral-light-alpha-100',
		text: 'text-neutral-light-alpha-100',
		border: 'border-neutral-light-alpha-100',
		from: 'from-neutral-light-alpha-100',
	},
	'neutral-light-alpha-200': {
		bg: 'bg-neutral-light-alpha-200',
		text: 'text-neutral-light-alpha-200',
		border: 'border-neutral-light-alpha-200',
		from: 'from-neutral-light-alpha-200',
	},
	'neutral-light-alpha-300': {
		bg: 'bg-neutral-light-alpha-300',
		text: 'text-neutral-light-alpha-300',
		border: 'border-neutral-light-alpha-300',
		from: 'from-neutral-light-alpha-300',
	},
	'neutral-light-alpha-400': {
		bg: 'bg-neutral-light-alpha-400',
		text: 'text-neutral-light-alpha-400',
		border: 'border-neutral-light-alpha-400',
		from: 'from-neutral-light-alpha-400',
	},
	'neutral-light-alpha-500': {
		bg: 'bg-neutral-light-alpha-500',
		text: 'text-neutral-light-alpha-500',
		border: 'border-neutral-light-alpha-500',
		from: 'from-neutral-light-alpha-500',
	},
	'neutral-dark': {
		bg: 'bg-neutral-dark',
		text: 'text-neutral-dark',
		border: 'border-neutral-dark',
		from: 'from-neutral-dark',
	},
	'neutral-dark-200': {
		bg: 'bg-neutral-dark-200',
		text: 'text-neutral-dark-200',
		border: 'border-neutral-dark-200',
		from: 'from-neutral-dark-200',
	},
	'neutral-dark-300': {
		bg: 'bg-neutral-dark-300',
		text: 'text-neutral-dark-300',
		border: 'border-neutral-dark-300',
		from: 'from-neutral-dark-300',
	},
	'neutral-dark-400': {
		bg: 'bg-neutral-dark-400',
		text: 'text-neutral-dark-400',
		border: 'border-neutral-dark-400',
		from: 'from-neutral-dark-400',
	},
	'neutral-dark-500': {
		bg: 'bg-neutral-dark-500',
		text: 'text-neutral-dark-500',
		border: 'border-neutral-dark-500',
		from: 'from-neutral-dark-500',
	},
	'neutral-dark-600': {
		bg: 'bg-neutral-dark-600',
		text: 'text-neutral-dark-600',
		border: 'border-neutral-dark-600',
		from: 'from-neutral-dark-600',
	},
	'neutral-dark-alpha-100': {
		bg: 'bg-neutral-dark-alpha-100',
		text: 'text-neutral-dark-alpha-100',
		border: 'border-neutral-dark-alpha-100',
		from: 'from-neutral-dark-alpha-100',
	},
	'neutral-dark-alpha-200': {
		bg: 'bg-neutral-dark-alpha-200',
		text: 'text-neutral-dark-alpha-200',
		border: 'border-neutral-dark-alpha-200',
		from: 'from-neutral-dark-alpha-200',
	},
	'neutral-dark-alpha-300': {
		bg: 'bg-neutral-dark-alpha-300',
		text: 'text-neutral-dark-alpha-300',
		border: 'border-neutral-dark-alpha-300',
		from: 'from-neutral-dark-alpha-300',
	},
	'neutral-dark-alpha-400': {
		bg: 'bg-neutral-dark-alpha-400',
		text: 'text-neutral-dark-alpha-400',
		border: 'border-neutral-dark-alpha-400',
		from: 'from-neutral-dark-alpha-400',
	},
	'neutral-dark-alpha-500': {
		bg: 'bg-neutral-dark-alpha-500',
		text: 'text-neutral-dark-alpha-500',
		border: 'border-neutral-dark-alpha-500',
		from: 'from-neutral-dark-alpha-500',
	},
	'lime-200': {
		bg: 'bg-lime-200',
		text: 'text-lime-200',
		border: 'border-lime-200',
		from: 'from-lime-200',
	},
	'lime-800': {
		bg: 'bg-lime-800',
		text: 'text-lime-800',
		border: 'border-lime-800',
		from: 'from-lime-800',
	},
	'teal-200': {
		bg: 'bg-teal-200',
		text: 'text-teal-200',
		border: 'border-teal-200',
		from: 'from-teal-200',
	},
	'teal-800': {
		bg: 'bg-teal-800',
		text: 'text-teal-800',
		border: 'border-teal-800',
		from: 'from-teal-800',
	},
	'yellow-200': {
		bg: 'bg-yellow-200',
		text: 'text-yellow-200',
		border: 'border-yellow-200',
		from: 'from-yellow-200',
	},
	'yellow-700': {
		bg: 'bg-yellow-700',
		text: 'text-yellow-700',
		border: 'border-yellow-700',
		from: 'from-yellow-700',
	},
	'purple-300': {
		bg: 'bg-purple-300',
		text: 'text-purple-300',
		border: 'border-purple-300',
		from: 'from-purple-300',
	},
	'purple-800': {
		bg: 'bg-purple-800',
		text: 'text-purple-800',
		border: 'border-purple-800',
		from: 'from-purple-800',
	},
	'blue-700': {
		bg: 'bg-fjord-blue-700',
		text: 'text-fjord-blue-700',
		border: 'border-fjord-blue-700',
		from: 'from-fjord-blue-700',
	},
	'green-success': {
		bg: 'bg-green-success',
		text: 'text-green-success',
		border: 'border-green-success',
		from: 'from-green-success',
	},
	'light-blue': {
		bg: 'bg-light-blue',
		text: 'text-light-blue',
		border: 'border-light-blue',
		from: 'from-light-blue',
	},
	'light-peach': {
		bg: 'bg-light-peach',
		text: 'text-light-peach',
		border: 'border-light-peach',
		from: 'from-light-peach',
	},
	'light-cream': {
		bg: 'bg-light-cream',
		text: 'text-light-cream',
		border: 'border-light-cream',
		from: 'from-light-cream',
	},
	'pale-orange': {
		bg: 'bg-pale-orange',
		text: 'text-pale-orange',
		border: 'border-pale-orange',
		from: 'from-pale-orange',
	},
	'light-lavender': {
		bg: 'bg-light-lavender',
		text: 'text-light-lavender',
		border: 'border-light-lavender',
		from: 'from-light-lavender',
	},
	transparent: {
		bg: 'bg-transparent',
		text: 'text-transparent',
		border: 'border-transparent',
		from: 'from-transparent',
	},
} as const

export type ColorMapping = typeof colorMapping
export type ValidColorType = keyof ColorMapping[ValidColorKey]
export type ValidMappedColor = ColorMapping[ValidColorKey][ValidColorType]

export const getColorVariant = (
	color: ValidColorKey | null | undefined,
	type: ValidColorType,
	defaultColor?: ValidColorKey,
): ValidMappedColor | '' => {
	if (color == null) {
		return defaultColor ? colorMapping[defaultColor][type] : ''
	}

	if (Object.keys(colorMapping).includes(color)) {
		return colorMapping[color][type]
	}

	return ''
}
